import(/* webpackMode: "eager" */ "/app/apps/ashtrom-engineering/app/[locale]/not-found.tsx");
